import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Box, Skeleton, CardContent, Grid } from "@mui/material";
import _ from "lodash";
import ArrowForwardTwoToneIcon from "@mui/icons-material/ArrowForwardTwoTone";
import ReturnOrderDetailCard from "../Common/ReturnOrderDetailCard";
import OrderService from "../../Services/OrderService";
import ReturnOrderStatusIcons from "./ReturnOrderStatusIcons";
import ErrorBoundary from "../Common/ErrorBoundary";
import TopBar from "../Common/TopBar";
import EmptyError from "../EmptyError/EmptyError";
import CommonConstantValues from "../../Services/CommonConstantValues";
import AnalyticsService from "../../Services/AnalyticsService";
import CreateReturnDialog from "../Common/CreateReturnDialog";
import BlockUi from "react-block-ui";
import InfiniteScroll from "react-infinite-scroll-component";

function ReturnOrders() {
  let navigate = useNavigate();
  const [returnOrders, setReturnOrders] = useState([]);
  const [loading, setLoading] = useState(CommonConstantValues.NOT_STARTED);
  const [currentPageCount, setCurrentPageCount] = useState(1);
  const [currentPageOrderCount, setCurrentPageOrderCount] = useState(0);

  useEffect(() => {
    const returnsPageViewed = {
      page: `/orders/return`,
    };
    AnalyticsService.pushEvent(`Page Viewed`, returnsPageViewed);
    const returnOrderCB = getReturnOrders();
    return returnOrderCB;
  }, []);

  const getReturnOrders = () => {
    setLoading(CommonConstantValues.STARTED);
    const { axiosRequest, abortController } =
      OrderService.getAllReturnOrdersList(currentPageCount);
    axiosRequest
      .then(({ data }) => {
        setLoading(CommonConstantValues.DONE);
        if (data?.responseData?.orders?.length) {
          _.forEach(data?.responseData?.orders, (items) => {
            items.statusDetails =
              ReturnOrderStatusIcons[items.status.toUpperCase()];
          });
          setReturnOrders((prevList) => [
            ...prevList,
            ...data.responseData.orders,
          ]);
          setCurrentPageCount(currentPageCount + 1);
          setCurrentPageOrderCount(data.responseData.orders.length);
        } else {
          setCurrentPageOrderCount(0);
        }
      })
      .catch((error) => {
        if (error?.message !== "canceled") {
          setLoading(CommonConstantValues.DONE);
        }
      });
    return () => abortController.abort();
  };

  const handleGoToOrderDetails = ({ orderId }) => {
    const orderDetailsClickedEvent = {
      page: `/orders/return`,
    };
    AnalyticsService.pushEvent(
      `Order Details Clicked`,
      orderDetailsClickedEvent
    );

    navigate(`/orders/return/order-detail?returnOrderId=${orderId}`);
  };

  return (
    <>
      <TopBar
        title={`Return History`}
        backNavigation={true}
        showHisaab={true}
      />

      <ErrorBoundary>
        <BlockUi
          tag="div"
          blocking={loading === "started"}
          message={`Loading...`}
          style={{ minHeight: "85vh" }}
          keepInView
        >
          <Container sx={{ padding: 0 }}>
            {returnOrders?.length ? (
              <InfiniteScroll
                dataLength={returnOrders?.length}
                next={getReturnOrders}
                hasMore={currentPageOrderCount !== 0}
                loader={<p style={{ textAlign: "center" }}>Loading...</p>}
                style={{ padding: "10px 16px 125px 16px" }}
              >
                {returnOrders?.map((order) => {
                  return (
                    <Box>
                      <ReturnOrderDetailCard
                        order={order}
                        needBottomBorderRadius={true}
                        key={order?.orderId}
                      />
                      <Box
                        sx={{
                          color: order?.canUploadBilty ? "#00733E" : "#9D2123",
                          cursor: "pointer",
                          display: "flex",
                          padding: "12px",
                          background: "#ffffff",
                          borderTop: "1px solid #eeeeee",
                          borderRadius: "0 0 8px 8px",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "700",
                          fontSize: "12px",
                        }}
                        onClick={() => handleGoToOrderDetails(order)}
                      >
                        {order?.canUploadBilty
                          ? `UPLOAD BILTY`
                          : `ORDER DETAILS`}
                        <ArrowForwardTwoToneIcon
                          sx={{
                            color: order?.canUploadBilty
                              ? `#00733E`
                              : `#9D2123`,
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </InfiniteScroll>
            ) : (
              loading === "done" && (
                <EmptyError
                  image={`Empty Cart.svg`}
                  text={`No Returns found!`}
                />
              )
            )}
          </Container>
        </BlockUi>
        <CreateReturnDialog title={`Create Return`} />
      </ErrorBoundary>
    </>
  );
}

export default ReturnOrders;
